export const SUCCESS = 'SUCCESS';
export const STEP = 'STEP';
export const RESPONSE = 'RESPONSE';
export const TRANSITION = 'TRANSITION';

export const SHOW_DIALOG = 'SHOW_DIALOG';
export const HIDE_DIALOG = 'HIDE_DIALOG';
